import { Controller } from "./helpers/controller.js";
import {ShowLoader} from "./utils/showLoader";


export class MemberSignupReturningCustomer extends Controller {

    private btnForwardWelcomeBack: JQuery = $('#btnFowardWelcomeBack');
    
    private welcomeBack: JQuery = $("[data-switch-welcome-back]");
    private navButtonsFull: JQuery = $("[data-switch-form-navigation-step-3]");
    private navButtonsBackOnly: JQuery = $("[data-switch-form-navigation-step-3-back]");
    private smsSelection: JQuery = $("[data-switch-sms-selected]");
    private emailSelection: JQuery = $("[data-switch-email-selected]");
    private btnSendAccessCode: JQuery = $("#btnSendAccessCode");
    private commsChoiceIsEmail: JQuery = $('[name="IsEmail"]');
    private lnkResendAccessCode: JQuery = $("#lnkSendAccessCode");
    private rdoReturningCustomer: JQuery = $('[name = "IsReturningCustomer"]');
    private pageWrap: JQuery = $('.pageWrap')
    private loader: JQuery = $('#loading-spinner')


    constructor(element: HTMLElement) {
        super(element);

        // Run this on load as could be a validation failure
        this.handleReturningCustomerSelected();
        this.selectCommsChoice();

        // Switch inputs based on Comms Choice
        this.commsChoiceIsEmail.on('click', (e) => {
            this.selectCommsChoice();
        });

        this.btnForwardWelcomeBack.on('click', (e) => {
            this.handleWelcomeBackChoice();
        });


        this.lnkResendAccessCode.on('click', (e) => {
            e.preventDefault();
            this.handleResendAccessCode();
        });

        this.rdoReturningCustomer.on('click', (e) => {
            this.handleReturningCustomerSelected();
        });

        this.btnSendAccessCode.on('click', (e) => {
            this.handleSendAccessCode();
        })

    }

    handleWelcomeBackChoice = () => {
        let isReturningCustomer = $("input[name='IsReturningCustomer']:checked");

        if (isReturningCustomer.val() !== 'true') {
            this.handleSubmitForm('formMemberSignupMain');
        } else {
            this.handleSubmitForm('formAccessCode');
        }
    }


    handleReturningCustomerSelected = () => {
        let isReturningCustomer = $("input[name='IsReturningCustomer']:checked");

        if (isReturningCustomer.length == 0) return;

        if (isReturningCustomer.val() !== 'true') {
            //Clear and Hide
            this.welcomeBack.hide();
            this.navButtonsBackOnly.hide();
            this.navButtonsFull.show();
            let isEmail = $("input[name='IsEmail']:checked");
            isEmail.ch
            this.smsSelection.find('input').val('');
            this.emailSelection.find('input').val('');
        } else {
            //Show
            this.welcomeBack.show();
            this.navButtonsFull.hide();
            this.navButtonsBackOnly.show();
        }
    }

    selectCommsChoice = () => {
        let isEmail = $("input[name='IsEmail']:checked");

        if (isEmail.length == 0) return;

        if (isEmail.val() === 'true') {
            this.smsSelection.find('input').val('');
            this.smsSelection.hide();
            this.emailSelection.show();
        } else {
            this.emailSelection.find('input').val('');
            this.emailSelection.hide();
            this.smsSelection.show();
        }

        this.btnSendAccessCode.prop('disabled', false);
        this.btnSendAccessCode.removeClass('disabled');
    }

    handleSubmitForm = (formId : string) => {
        let form = <HTMLFormElement>document.getElementById(formId);
        this.submitForm(form);
    }

    handleSendAccessCode = () => {
        this.btnSendAccessCode.addClass('disabled');
        this.btnSendAccessCode.prop('disabled', true);
        this.handleSubmitForm('formAccessCode');
    }

    handleResendAccessCode = () => {
        this.lnkResendAccessCode.addClass('disabled');
        this.lnkResendAccessCode.attr('href', '');
        this.handleSubmitForm(this.lnkResendAccessCode.data('form-id'));
    }

    submitForm = (form: HTMLFormElement) => {
        if (form !== null) {
            if ("useSpinner" in form.dataset) {
                ShowLoader(this.loader);
            }
            form.submit();
        }
    }
    
}


